import { Button, Modal, notification } from 'antd'
import axios from 'axios'
import React, { useState } from 'react'

import { emptyCharacter } from '../../../../components/EmptyChar'
import { messages } from '../../messages'
import { RfqEmail } from '../../models'

interface DeleteBespokeRfqEmailDrawerProps {
  rfqEmail: RfqEmail
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeleteBespokeRfqEmailModal = ({
  rfqEmail,
  isVisible,
  onClose,
  onSuccess,
}: DeleteBespokeRfqEmailDrawerProps) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (rfqEmailId: number) => {
    setIsDeleting(true)

    try {
      await axios.delete(`/rfqs/emails/${rfqEmailId}`)
      onSuccess()

      notification.success({ message: messages.common.success, description: messages.deleteRfqEmail.success })
    } catch (error) {
      notification.error({
        message: messages.common.error,
        description: error.error_message || messages.deleteRfqEmail.error,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete bespoke RFQ Email"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => onDelete(rfqEmail.id)}
            disabled={isDeleting}
            loading={isDeleting}
            type="primary"
            danger
          >
            Delete
          </Button>
        </div>,
      ]}
    >
      {buildDeleteMessage(rfqEmail)}
    </Modal>
  )
}

const buildDeleteMessage = (rfqEmail: RfqEmail) =>
  `Are you sure that you want to delete this RFQ email?\n
  - Display Name: ${rfqEmail?.name}\n
  - Issuer: ${rfqEmail?.issuerId}\n
  - Tenant: ${rfqEmail?.tenantId ? rfqEmail?.tenantId : 'Any'}\n
  - Instrument: ${rfqEmail?.instrumentCode === emptyCharacter ? 'Any' : rfqEmail?.instrumentCode}\n
  It cannot be reverted`
